import digitalEcosystem from "../../assets/images/success-stories/digital-ecosystem.webp";
import cdprRetail from "../../assets/images/success-stories/cdpr_retail.webp";
import rwanda from "../../assets/images/success-stories/rwanda.webp";
import CXAdidas from "../../assets/images/success-stories/CX_-Adidas-1.webp";
import IntellSenseAdidas from "../../assets/images/success-stories/IntellSense_Adidas.webp";
import DatascienceMnS from "../../assets/images/success-stories/Datascience_MnS.webp";
import CDPMnS from "../../assets/images/success-stories/CDP-MnS.webp";
import MarketingOpsMnS from "../../assets/images/success-stories/MarketingOps_MnS.webp";
import CampaignMnS from "../../assets/images/success-stories/Campaign-MnS-1.webp";
import CDPAdidas3 from "../../assets/images/success-stories/CDP_Adidas-3.webp";
import MarketingOpsAdidas1 from "../../assets/images/success-stories/MarketingOps_Adidas-1.webp";
import DataEnggAdidas3 from "../../assets/images/success-stories/DataEngg_Adidas-3.webp";
import DataOpsAdidas from "../../assets/images/success-stories/DataOps-Adidas.webp";
import DataOpsReebok1 from "../../assets/images/success-stories/DataOps_Reebok-1.webp";
import CampaignReebok from "../../assets/images/success-stories/Campaign-Reebok.webp";
import PortalenggMorocco from "../../assets/images/success-stories/Portal-engg_Morocco.jpg";
import DataEnggReebok from "../../assets/images/success-stories/DataEngg_Reebok.webp";
import BIVisualizationAdidas from "../../assets/images/success-stories/BI-Visualization_Adidas-1.webp";
import BIVisualizationWarehouseNew from "../../assets/images/success-stories/BI-Visualization_Warehouse-new-1.webp";
import DataScienceWarehouse from "../../assets/images/success-stories/DataScience_Warehouse.webp";
import DigitalEnggRwanda from "../../assets/images/success-stories/Digital-Engg_Rwanda.webp";
import ConsultingAdidas from "../../assets/images/success-stories/Consulting_Adidas-1.webp";
import CampaignAdidas from "../../assets/images/success-stories/Campaign-Adidas.webp";
import ConsultingMnS from "../../assets/images/success-stories/Consulting-MnS.webp";
import CXHamleys from "../../assets/images/success-stories/CX_Hamleys-3.webp";
import KleanMailAdidas from "../../assets/images/success-stories/KleanMail_Adidas.webp";
import SearchDeborah from "../../assets/images/success-stories/Search_Deborah-1.webp";
import SearchJeromes from "../../assets/images/success-stories/Search_Jeromes.webp";
import cdpCaseStudy1 from "../../assets/images/success-stories/cdp-case-study-aviation-passenger-data-platform-personalization-acquisition-revenue-growth.png";
import cdpCaseStudy2 from "../../assets/images/success-stories/cdp-case-study-ecommerce-real-time-segmentation-campaign-optimization-conversion-growth.png";
import cdpCaseStudy3 from "../../assets/images/success-stories/cdp-case-study-healthcare-identity-resolution-patient-360-retention-repeat-bookings.png";
import cdpCaseStudy4 from "../../assets/images/success-stories/cdp-case-study-retail-churn-prediction-customer-reactivation-repeat-revenue.png";
import cdpCaseStudy5 from "../../assets/images/success-stories/cdp-case-study-retail-data-unification-customer-360-sales-uplift-acquisition.png";
import cdpCaseStudy6 from "../../assets/images/success-stories/cdp-case-study-retail-unified-customer-view-personalization-conversion-retention2.png";
import cdpCaseStudy7 from "../../assets/images/success-stories/cdp-case-study-retail-unified-customer-view-personalization-conversion-retention.png";
import cdpCaseStudy8 from "../../assets/images/success-stories/cdp-case-study-telecom-churn-prediction-customer-analytics-retention-personalization.png";


import DataEnggReebokPdfFile from "../../assets/images/success-stories/pdf/DataEngg_Reebok.pdf";
import DataOpsAdidasPdfFile from "../../assets/images/success-stories/pdf/DataOps_Adidas.pdf";
import DataOpsReebokPdfFile from "../../assets/images/success-stories/pdf/DataOps_Reebok.pdf";
import DatascienceMnSPdfFile from "../../assets/images/success-stories/pdf/Datascience_MnS.pdf";
import DataScienceWarehousePdfFile from "../../assets/images/success-stories/pdf/DataScience_Warehouse.pdf";
import DigitalEnggRwandaPdfFile from "../../assets/images/success-stories/pdf/Digital_Engg_Rwanda.pdf";
import PortalenggMoroccoPdfFile from "../../assets/images/success-stories/pdf/Portal_engg_Morocco.pdf";
import CdpReadyAutomotivePdfFile from "../../assets/images/success-stories/pdf/CDP-ready_Automotive.pdf";
import cdprRetailPdfFile from "../../assets/images/success-stories/pdf/CDP-Ready_retail.pdf";
import BIVisualizationRISAGCCPdfFile from "../../assets/images/success-stories/pdf/BI Visualization_RISA GCC 1.pdf";
import CXAdidasPdfFile from "../../assets/images/success-stories/pdf/CX_ Adidas3.pdf";
import IntellSenseAdidasPdfFile from "../../assets/images/success-stories/pdf/IntellSense_Adidas.pdf";
import Campaign_MnSPdfFile from "../../assets/images/success-stories/pdf/Campaign_MnS.pdf";
import MarketingOpsMnSPdfFile from "../../assets/images/success-stories/pdf/MarketingOps_MnS.pdf";
import CDP_MnS3PdfFile from "../../assets/images/success-stories/pdf/CDP_MnS3.pdf";
import Adidas_CDP1PdfFile from "../../assets/images/success-stories/pdf/Adidas_CDP1.pdf";
import MarketingOps_Adidas2PdfFile from "../../assets/images/success-stories/pdf/MarketingOps_Adidas2.pdf";
import DataEngg_Adidas2PdfFile from "../../assets/images/success-stories/pdf/DataEngg_Adidas2.pdf";
import Campaign_Reebok1sPdf from "../../assets/images/success-stories/pdf/Campaign_Reebok1.pdf";
import BIVisualizationAdidasPdfFile from "../../assets/images/success-stories/pdf/BI Visualization_Adidas.pdf";
import BIVisualizationWarehouse1PdfFile from "../../assets/images/success-stories/pdf/BI Visualization_Warehouse1.pdf";
import ConsultingMnSPdfFile from "../../assets/images/success-stories/pdf/Consulting_Adidas 2.pdf";
import CampaignAdidas2PdfFile from "../../assets/images/success-stories/pdf/Campaign_Adidas2.pdf";
import ALeadingMultinationalRetailerExpeditedTheirGTMPdfFile from "../../assets/images/success-stories/pdf/Consulting_MnS.pdf";
import CXHamleys1PdfFile from "../../assets/images/success-stories/pdf/CX_Hamleys1.pdf";
import KleanMailAdidasPdfFile from "../../assets/images/success-stories/pdf/KleanMail_Adidas1.pdf";
import SearchDeborahPdfFile from "../../assets/images/success-stories/pdf/Search_Deborah.pdf";
import SearchJeromesPdfFile from "../../assets/images/success-stories/pdf/Search_Jeromes.pdf";
import cdpCaseStudy1PdfFile from "../../assets/images/success-stories/pdf/cdp-case-study-aviation-passenger-data-platform-personalization-acquisition-revenue-growth.pdf";
import cdpCaseStudy2PdfFile from "../../assets/images/success-stories/pdf/cdp-case-study-ecommerce-real-time-segmentation-campaign-optimization-conversion-growth.pdf";
import cdpCaseStudy3PdfFile from "../../assets/images/success-stories/pdf/cdp-case-study-healthcare-identity-resolution-patient-360-retention-repeat-bookings.pdf";
import cdpCaseStudy4PdfFile from "../../assets/images/success-stories/pdf/cdp-case-study-retail-churn-prediction-customer-reactivation-repeat-revenue.pdf";
import cdpCaseStudy5PdfFile from "../../assets/images/success-stories/pdf/cdp-case-study-retail-data-unification-customer-360-sales-uplift-acquisition.pdf";
import cdpCaseStudy6PdfFile from "../../assets/images/success-stories/pdf/cdp-case-study-retail-omnichannel-marketing-churn-reactivation-revenue-recovery.pdf";
import cdpCaseStudy7PdfFile from "../../assets/images/success-stories/pdf/cdp-case-study-retail-unified-customer-view-personalization-conversion-retention.pdf";
import cdpCaseStudy8PdfFile from "../../assets/images/success-stories/pdf/cdp-case-study-telecom-churn-prediction-customer-analytics-retention-personalization.pdf";


export const successStories = [
  {
    id: 1,
    title:
      "Driving 23X Passenger Acquisition and 16% Ancillary Revenue Growth Through AIPowered Passenger Data Intelligence",
    slug: "cdp-case-study-aviation-passenger-data-platform-personalization-acquisition-revenue-growth",
    excerpt: "",
    image: cdpCaseStudy1,
    details: [""],
    pdfFile: cdpCaseStudy1PdfFile,
  },
  {
    id: 2,
    title:
      "Accelerating Campaign Execution by 23% Through No-Code Segmentation Across 50M+ Records",
    slug: "cdp-case-study-ecommerce-real-time-segmentation-campaign-optimization-conversion-growth",
    excerpt: "",
    image: cdpCaseStudy2,
    details: [""],
    pdfFile: cdpCaseStudy2PdfFile,
  },
  {
    id: 3,
    title:
      "How a Unified Customer Data Platform Drove 32% Growth in Repeat Diagnostic Test Bookings",
    slug: "cdp-case-study-healthcare-identity-resolution-patient-360-retention-repeat-bookings",
    excerpt: "",
    image: cdpCaseStudy3,
    details: [""],
    pdfFile: cdpCaseStudy3PdfFile,
  },
  {
    id: 4,
    title:
      "Delivering 5% Repeat Revenue Growth in 30 Days Through Structured Churn Intelligence",
    slug: "cdp-case-study-retail-churn-prediction-customer-reactivation-repeat-revenue",
    excerpt: "",
    image: cdpCaseStudy4,
    details: [""],
    pdfFile: cdpCaseStudy4PdfFile,
  },
  {
    id: 5,
    title:
      "Delivering 309K+ Customers and 9% Sales Uplift Through a Unified CDP Strategy",
    slug: "cdp-case-study-retail-data-unification-customer-360-sales-uplift-acquisition",
    excerpt: "",
    image: cdpCaseStudy5,
    details: [""],
    pdfFile: cdpCaseStudy5PdfFile,
  },
  {
    id: 6,
    title:
      "Data-Driven Omnichannel Activation Delivering $1.06M Revenue Recovery and 5.13% Cost Savings",
    slug: "cdp-case-study-retail-omnichannel-marketing-churn-reactivation-revenue-recovery",
    excerpt: "",
    image: cdpCaseStudy6,
    details: [""],
    pdfFile: cdpCaseStudy6PdfFile,
  },
  {
    id: 7,
    title:
      "Driving 17% Higher Conversions and 15% Better Retention with Connected Customer Insights",
    slug: "cdp-case-study-retail-unified-customer-view-personalization-conversion-retention",
    excerpt: "",
    image: cdpCaseStudy7,
    details: [""],
    pdfFile: cdpCaseStudy7PdfFile,
  },
  {
    id: 8,
    title: "18% Churn Reduction Through Unified Telecom Analytics",
    slug: "cdp-case-study-telecom-churn-prediction-customer-analytics-retention-personalization",
    excerpt: "",
    image: cdpCaseStudy8,
    details: [""],
    pdfFile: cdpCaseStudy8PdfFile,
  },
  {
    id: 9,
    title:
      "An Automotive Leader’s High-Octane Transformation with CDP Readiness Assessment",
    slug: "cdp-readiness-assessment",
    excerpt: "",
    image: digitalEcosystem,
    details: [""],
    pdfFile: CdpReadyAutomotivePdfFile,
  },
  {
    id: 10,
    title: "Igniting a Global Sporting Revolution with CDP-Readiness",
    slug: "global-sporting-cdp-readiness",
    excerpt: "",
    image: cdprRetail,
    details: [""],
    pdfFile: cdprRetailPdfFile,
  },
  {
    id: 11,
    title:
      "The Government of an African Nation Races Forward in Achieving Wellbeing, Sustainability, and Development Goals with the Power of Elasticsearch",
    slug: "african-nation-public-sector-digitalization",
    excerpt: "",
    image: rwanda,
    details: [""],
    pdfFile: BIVisualizationRISAGCCPdfFile,
  },
  {
    id: 12,
    title:
      "Transforming abandoned carts into a source of revenue and reclaiming sales for a leading global sportswear company",
    slug: "transforming-abandoned-carts-into-a-source-of-revenue-and-reclaiming-sales-for-a-leading-global-sportswear-company",
    excerpt: "",
    image: CXAdidas,
    details: [""],
    pdfFile: CXAdidasPdfFile,
  },
  {
    id: 13,
    title:
      "The second largest global footwear company gains real-time visibility into their business performance with BI dashboards and make quick data- driven decisions, resulting in increased efficiency & profitability",
    slug: "the-second-largest-global-footwear-company-gains-real-time-visibility-into-their-business-performance-with-bi-dashboards-and-make-quick-data-driven-decisions-resulting-in-increased-efficiency-pr",
    excerpt: "",
    image: IntellSenseAdidas,
    details: [""],
    pdfFile: IntellSenseAdidasPdfFile,
  },
  {
    id: 14,
    title:
      "The largest fashion retail brand of the UK uses predictive analytics & improves wallet share per customer by 13% in less than 3 months",
    slug: "the-largest-fashion-retail-brand-of-the-uk-uses-predictive-analytics-improves-wallet-share-per-customer-by-13-in-less-than-3-months",
    excerpt: "",
    image: DatascienceMnS,
    details: [""],
    pdfFile: DatascienceMnSPdfFile,
  },
  {
    id: 15,
    title:
      "The largest fashion retail brand of the UK improves wallet share per customer by 13% in less than 3 months with data-driven approach",
    slug: "the-largest-fashion-retail-brand-of-the-uk-improves-wallet-share-per-customer-by-13-in-less-than-3-months-with-data-driven-approach",
    excerpt: "",
    image: CDPMnS,
    details: [""],
    pdfFile: CDP_MnS3PdfFile,
  },
  {
    id: 16,
    title:
      "The largest fashion retail brand of the UK deploys omnichannel platform to increase personalized engagement and conversions",
    slug: "the-largest-fashion-retail-brand-of-the-uk-deploys-omnichannel-platform-to-increase-personalized-engagement-and-conversions",
    excerpt: "",
    image: MarketingOpsMnS,
    details: [""],
    pdfFile: MarketingOpsMnSPdfFile,
  },
  {
    id: 17,
    title:
      "The largest fashion retail brand in the UK increased their response ratio by more than 40% in 6 weeks by using Comsense accelerators",
    slug: "the-largest-fashion-retail-brand-in-the-uk-increased-their-response-ratio-by-more-than-40-in-6-weeks-by-using-comsense-accelerators",
    excerpt: "",
    image: CampaignMnS,
    details: [""],
    pdfFile: Campaign_MnSPdfFile,
  },
  {
    id: 18,
    title:
      "The 2nd largest sportswear company in the world improves wallet share per customer by 4% within 3 months post Comsense’s CDP implementation",
    slug: "the-2nd-largest-sportswear-company-in-the-world-improves-wallet-share-per-customer-by-4-within-3-months-post-comsenses-cdp-implementation",
    excerpt: "",
    image: CDPAdidas3,
    details: [""],
    pdfFile: Adidas_CDP1PdfFile,
  },
  {
    id: 19,
    title:
      "The 2nd largest sportswear company in the world improved their revenue via net new customer acquisition by 4% in two months",
    slug: "the-2nd-largest-sportswear-company-in-the-world-improved-their-revenue-via-net-new-customer-acquisition-by-4-in-two-months",
    excerpt: "",
    image: MarketingOpsAdidas1,
    details: [""],
    pdfFile: MarketingOps_Adidas2PdfFile,
  },
  {
    id: 20,
    title:
      "The 2nd largest sportswear company in the world improved delivery of high-quality data to enable faster and more reliable decision-making",
    slug: "the-2nd-largest-sportswear-company-in-the-world-improved-delivery-of-high-quality-data-to-enable-faster-and-more-reliable-decision-making",
    excerpt: "",
    image: DataEnggAdidas3,
    details: [""],
    pdfFile: DataEngg_Adidas2PdfFile,
  },
  {
    id: 21,
    title:
      "The 2nd largest sportswear company in the world effortlessly scaled their data management processes",
    slug: "the-2nd-largest-sportswear-company-in-the-world-effortlessly-scaled-their-data-management-processes",
    excerpt: "",
    image: DataOpsAdidas,
    details: [""],
    pdfFile: DataOpsAdidasPdfFile,
  },
  {
    id: 22,
    title:
      "Reebok overcomes data quality issues and reduces data management costs",
    slug: "reebok-overcomes-data-quality-issues-and-reduces-data-management-cost",
    excerpt: "",
    image: DataOpsReebok1,
    details: [""],
    pdfFile: DataOpsReebokPdfFile,
  },
  {
    id: 23,
    title:
      "Reebok deploys Marketing Automation and achieves ROI within 120 days",
    slug: "reebok-deploys-marketing-automation-and-achieves-roi-within-120-days",
    excerpt: "",
    image: CampaignReebok,
    details: [""],
    pdfFile: Campaign_Reebok1sPdf,
  },
  {
    id: 24,
    title:
      "Increased collaboration and sustainable economic development by leveraging digital transformation",
    slug: "increased-collaboration-and-sustainable-economic-development-by-leveraging-digital-transformation",
    excerpt: "",
    image: PortalenggMorocco,
    details: [""],
    pdfFile: PortalenggMoroccoPdfFile,
  },
  {
    id: 25,
    title:
      "How Reebok gained competitive edge through data driven decision making and insights",
    slug: "how-reebok-gained-competitive-edge-through-data-driven-decision-making-and-insights",
    excerpt: "",
    image: DataEnggReebok,
    details: [""],
    pdfFile: DataEnggReebokPdfFile,
  },
  {
    id: 26,
    title:
      "From Shoeboxes to Dashboards: How Comsense enabled one of the second largest sportswear brands to transform their business with data-driven insights",
    slug: "from-shoeboxes-to-dashboards-how-comsense-enabled-one-of-the-second-largest-sportswear-brands-to-transform-their-business-with-data-driven-insights",
    excerpt: "",
    image: BIVisualizationAdidas,
    details: [""],
    pdfFile: BIVisualizationAdidasPdfFile,
  },
  {
    id: 27,
    title:
      "From data chaos to business insights for the largest retail brand in New Zealand specialized in outdoor and adventure sports equipment",
    slug: "from-data-chaos-to-business-insights-for-the-largest-retail-brand-in-new-zealand-specialized-in-outdoor-and-adventure-sports-equipment",
    excerpt: "",
    image: BIVisualizationWarehouseNew,
    details: [""],
    pdfFile: BIVisualizationWarehouse1PdfFile,
  },
  {
    id: 28,
    title:
      "Data science to step up the retail game for the largest retail brand in New Zealand specialized in outdoor and adventure sports equipment",
    slug: "data-science-to-step-up-the-retail-game-for-the-largest-retail-brand-in-new-zealand-specialized-in-outdoor-and-adventure-sports-equipment",
    excerpt: "",
    image: DataScienceWarehouse,
    details: [""],
    pdfFile: DataScienceWarehousePdfFile,
  },
  {
    id: 29,
    title:
      "An international development corporation leverages digitalization to accelerate progress towards sustainability and development goals of an African Republic through enhanced data analytics",
    slug: "an-international-development-corporation-leverages-digitalization-to-accelerate-progress-towards-sustainability-and-development-goals-of-an-african-republic-through-enhanced-data-analytics",
    excerpt: "",
    image: DigitalEnggRwanda,
    details: [""],
    pdfFile: DigitalEnggRwandaPdfFile,
  },
  {
    id: 30,
    title:
      "A leading multinational Sportswear Corporation is sprinting for their next phase of growth by virtue of Strategy Consulting",
    slug: "a-leading-multinational-sportswear-corporation-is-sprinting-for-their-next-phase-of-growth-by-virtue-of-strategy-consulting",
    excerpt: "",
    image: ConsultingAdidas,
    details: [""],
    pdfFile: ConsultingMnSPdfFile,
  },
  {
    id: 31,
    title:
      "A leading multinational Sportswear Brand implements 80+ automated workflows and boosts conversion rates by 40%",
    slug: "a-leading-multinational-sportswear-brand-implements-80-automated-workflows-and-boosts-conversion-rates-by-40",
    excerpt: "",
    image: CampaignAdidas,
    details: [""],
    pdfFile: CampaignAdidas2PdfFile,
  },
  {
    id: 32,
    title:
      "A leading multinational retailer expedited their GTM time and witnessed multifold customer registrations following Technology Consulting Initiative",
    slug: "a-leading-multinational-retailer-expedited-their-gtm-time-and-witnessed-multifold-customer-registrations-following-technology-consulting-initiative",
    excerpt: "",
    image: ConsultingMnS,
    details: [""],
    pdfFile: ALeadingMultinationalRetailerExpeditedTheirGTMPdfFile,
  },
  {
    id: 33,
    title:
      "A leading global multinational toy retailer proactively eliminates customer struggles and dramatically improves online conversions",
    slug: "a-leading-global-multinational-toy-retailer-proactively-eliminates-customer-struggles-and-dramatically-improves-online-conversions",
    excerpt: "",
    image: CXHamleys,
    details: [""],
    pdfFile: CXHamleys1PdfFile,
  },
  {
    id: 34,
    title:
      "A Leading Global Multinational Sportswear Brand Experiences a Dramatic Boost in Their RoI with Email Validation",
    slug: "a-leading-global-multinational-sportswear-brand-experiences-a-dramatic-boost-in-their-roi-with-email-validation",
    excerpt: "",
    image: KleanMailAdidas,
    details: [""],
    pdfFile: KleanMailAdidasPdfFile,
  },
  {
    id: 35,
    title:
      "A leading beauty brand uses a mix of site search, personalized recommendations, and clever merchandising to witness 45% increase in orders",
    slug: "a-leading-beauty-brand-uses-a-mix-of-site-search-personalized-recommendations-and-clever-merchandising-to-witness-45-increase-in-orders",
    excerpt: "",
    image: SearchDeborah,
    details: [""],
    pdfFile: SearchDeborahPdfFile,
  },
  {
    id: 36,
    title:
      "A furniture retail store offers bespoke AI-powered search & recommendation experiences to their shoppers and witnesses 20% increased revenue from site search",
    slug: "a-furniture-retail-store-offers-bespoke-ai-powered-search-recommendation-experiences-to-their-shoppers-and-witnesses-20-increased-revenue-from-site-search",
    excerpt: "",
    image: SearchJeromes,
    details: [""],
    pdfFile: SearchJeromesPdfFile,
  },
];
